import { render, staticRenderFns } from "./KusBaseDateField.vue?vue&type=template&id=34e3d413"
import script from "./KusBaseDateField.vue?vue&type=script&lang=js"
export * from "./KusBaseDateField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports